<div class="mapContent"> 
    <app-source-map></app-source-map>
</div>

<div class="parcelfields">
    <h2>اختيار قطعة الأرض</h2>
      <div class="input-field">
        <label for="baladeya"> البلدية </label>
        <select id="baladeya" (change)="onBaladeyaNameChange($event)">
          <option value="">All</option>
          <option *ngFor="let option of baladeyaNameOptions" [value]="option">
            {{ option }}
          </option>
        </select>
      </div>

      <div class="input-field">
        <label for="neigh"> اسم الحي </label>
        <select id="neigh" (change)="onNeighNameChange($event)">
          <option value="">All</option>
          <option *ngFor="let option of neighNameOptions" [value]="option">
            {{ option }}
          </option>
        </select>
      </div>
     
      <div class="input-field">
        <label for="planName"> اسم المخطط </label>
        <select id="planName" (change)="onPlanNameChange($event)">
          <option value="">All</option>
          <option *ngFor="let option of planNameOptions" [value]="option">
            {{ option }}
          </option>
        </select>
      </div>
      <div class="input-field">
        <label for="parcelno"> رقم القطعة </label>
        <select id="parcelno" (change)="onParcelNoChange($event)">
          <option value="">All</option>
          <option *ngFor="let option of parcelNoOptions" [value]="option">
            {{ option }}
          </option>
        </select>
      </div>
  <div style="overflow-y: scroll; height: 40vh;">
      <div class="input-field">
        <label for="northBorder">الحد الشمالي</label>
        <input type="text" id="northBorder" [(ngModel)]="northBorder">
       </div>

       <div class="input-field">
        <label for="southBorder">الحد الجنوبي</label>
        <input type="text" id="southBorder" [(ngModel)]="southBorder">
       </div>

       <div class="input-field">
        <label for="eastBorder">الحد الشرقي</label>
        <input type="text" id="eastBorder" [(ngModel)]="eastBorder">
       </div>

       <div class="input-field">
        <label for="westBorder">الحد الغربي</label>
        <input type="text" id="westBorder" [(ngModel)]="westBorder">
       </div>

       <div class="input-field">
        <label for="northLength">طول الحد الشمالي</label>
        <input type="text" id="northLength" [(ngModel)]="northLength">
       </div>

       <div class="input-field">
        <label for="southLength">طول الحد الجنوبي</label>
        <input type="text" id="southLength" [(ngModel)]="southLength">
       </div>

       <div class="input-field">
        <label for="eastLength">طول الحد الشرقي</label>
        <input type="text" id="eastLength" [(ngModel)]="eastLength">
       </div>

       <div class="input-field">
        <label for="westLength">طول الحد الغربي</label>
        <input type="text" id="westLength" [(ngModel)]="westLength">
       </div>

       <div class="input-field">
        <label for="breaksLength">طول الشطفة</label>
        <input type="text" id="breaksLength" [(ngModel)]="breaksLength">
       </div>
  </div>
  <button class="btn btn-primary" (click)="saveParcelEdits()">save</button>
</div>